































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
import { EventBus } from "@/pitprojekt/event-bus";
import GoogleMapDialog from "@/components/dialog/GoogleMapDialog.vue";
import { Product } from "@/pitprojekt/models/Product";
import { Utils } from '@/pitprojekt/utils';
import DetailedStatsTable from "@/components/table/DetailedStatsTable.vue";
import { DataTablePaginatorAndProduct } from "@/store/modules/dashboard/types";
import { ProductAggregatedStatPobrania, ProductDetailedStatPobrania } from "@/store/modules/statsPobrania/types";
import { Pagination } from "@/pitprojekt/types";
import { StatsTableHeaders } from '@/views/elements/stats-table-headers'
const StatsPobraniaModule = namespace('StatsPobraniaModule')
const SettingsModule = namespace('SettingsModule')
import { StatsPobraniaService } from "@/services/stats-pobrania.service"
import _ from 'lodash'

@Component({
    components: { GoogleMapDialog, DetailedStatsTable }
})
export default class StatsPobraniaTable extends Vue {
    @SettingsModule.Getter('selectedProduct') selectedProduct!:number;
    @SettingsModule.Getter('selectedProductObject') selectedProductObject!:Product;
    @SettingsModule.Getter('lastYear') lastYear!:boolean;
    @StatsPobraniaModule.Getter('aggregatedStatsPobrania') aggregatedStatsPobrania! :Array<object>;
    @StatsPobraniaModule.Getter('aggregatedStatsPobraniaTotal') aggregatedStatsPobraniaTotal! :number;
    @StatsPobraniaModule.Getter('aggregatedStatsPobraniaLoading') aggregatedStatsPobraniaLoading! :number;
    @StatsPobraniaModule.Action('getAggregatedStatsPobraniaBetweenDatesForProduct') getAggregatedStatsPobraniaBetweenDatesForProduct: any;
    @SettingsModule.Action('changeSelectedProduct') changeSelectedProduct: any;
    pagination: Pagination = {};
    expanded: Array<ProductAggregatedStatPobrania> = [];
    detailedStatsPobrania: Array<ProductDetailedStatPobrania> = [];
    uruchomienTotal: number = 0;
    statsFromWindowsPercent: number = 0;
    isDetailedStatsPobraniaLoading: boolean = false;
    headers: object = StatsTableHeaders.aggregatedStatsHeader();
    headersIn: object = StatsTableHeaders.detailedStatsPobraniaHeader();


    created() {
        this.changeSelectedProduct(this.$route.params.id);
        EventBus.$on('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    beforeDestroy() {
        EventBus.$off('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    goToStatsBrowsing() {
        this.$router.push({ name: 'stats-pobrania-details-index', params: { id: ''+this.selectedProduct } });
    }

    pageTitleDateChanged() {
        this.getAggregatedStatsPobraniaBetweenDatesForProduct(this.dataTablePaginatorAndProduct);
    }

    getProductIconName(rodzaj: string): string {
        return Utils.getProductIconName(rodzaj);
    }

    @Watch('selectedProduct')
    onSelectedProductChanged() {
        if (this.$route.params.id != this.selectedProduct.toString()) {
            this.getAggregatedStatsPobraniaBetweenDatesForProduct(this.dataTablePaginatorAndProduct);
            this.$router.push({ name: 'stats-pobrania-product', params: { id: ''+this.selectedProduct } });
        }
    }

    @Watch('pagination')
    onPagination() {
        this.getAggregatedStatsPobraniaBetweenDatesForProduct(this.dataTablePaginatorAndProduct);
    }

    @Watch('expanded')
    onExpandedChanged() {
        this.detailedStatsPobrania = [];
        this.uruchomienTotal = 0;
        this.statsFromWindowsPercent = 0
        this.isDetailedStatsPobraniaLoading = true;
        if (this.expanded.length > 0) this.getDetailedStatsPobrania();
    }

    get dataTablePaginatorAndProduct(): DataTablePaginatorAndProduct {
        return <DataTablePaginatorAndProduct> {
            'productId' : this.selectedProduct,
            'page': this.pagination.page,
            'itemsPerPage': this.pagination.itemsPerPage,
            'lastYear': this.lastYear
        }
    }

    async getDetailedStatsPobrania() {
        this.detailedStatsPobrania = await StatsPobraniaService.getDetailedListBetweenDates(this.selectedProduct, this.expanded[0].data, this.expanded[0].data, this.lastYear);
        this.isDetailedStatsPobraniaLoading = false;
        this.uruchomienTotal = _.sumBy(this.detailedStatsPobrania, 'uruchomienia_count');
        this.statsFromWindowsPercent = (_.filter(this.detailedStatsPobrania, function(o:ProductDetailedStatPobrania) { if (o.os == 'Windows') return o }).length / this.detailedStatsPobrania.length) * 100;
    }

    isWeekend(date: string):boolean {
        return Utils.isWeekend(date);
    }

    toggleExpandRow(item:ProductAggregatedStatPobrania) {
        this.expanded = item === this.expanded[0] ? [] : [item];
    }

    isRowExpanded(item:ProductAggregatedStatPobrania):boolean {
        return (item === this.expanded[0]);
    }

    showGoogleMapDialogByIP(ip: string) {
      EventBus.$emit('showGoogleMapDialogByIPEvent', ip);
    }

}
